import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Problems() {
  return <section className="bg-paper" data-id="element-244" data-mp="36y3ty1f5yeiz">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-245" data-mp="324992untntib">
        <SectionHeading eyebrow="Quizás te resulte familiar" title={<>
              Seguro en tu casa pasa <span className="text-clay" data-id="element-247" data-mp="2t4311oaw7lqj">al menos una</span> de estas
              cosas...
            </>} subtitle="A veces no sabemos exactamente qué cambiar. Simplemente sentimos que ciertos espacios no terminan de funcionar como nos gustaría." data-id="element-246" data-mp="2y3pdhviwcxya" />

        <ul className="mx-auto mt-12 grid max-w-4xl gap-x-10 gap-y-6 sm:mt-16 sm:grid-cols-2 sm:gap-y-7" data-id="element-248" data-mp="2j6owalyc0le2">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3.5" data-id="element-249" data-mp="2f6y022q1dd25">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-clay-tint" aria-hidden="true" data-id="element-250" data-mp="hea6l0pjqcn3">
                <XIcon className="h-4 w-4 text-clay" strokeWidth={2.5} data-id="element-251" data-mp="34qv0ccntocg9" />
              </span>
              <p className="text-[15px] leading-[1.6] text-ink sm:text-[16px]" data-id="element-252" data-mp="34t7ppavwtp3c">{problem}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[19px] font-semibold leading-[1.45] text-ink sm:mt-16 sm:text-[24px]" data-id="element-253" data-mp="2vqgd37rasna4">
          Muchas veces no necesitás cambiar de casa. Necesitás aprender a{' '}
          <span className="text-clay underline decoration-clay/40 decoration-2 underline-offset-4" data-id="element-254" data-mp="3nie3qklrdsit">
            mirar de otra manera
          </span>{' '}
          la que ya tenés.
        </p>
      </div>
    </section>;
}